/**
 * 设置（支付，通知）
 */

import axios from '@/api/http'; // 导入http中创建的axios实例
import base from '@/api/base'; // 导入接口域名列表
const setting = {
  /**
   * payconfig(支付配置信息)Pay Config Controller
   */
  // POST/payconfig/payConfig 支付配置(支付宝/微信)------ygt
  payConfig() {
    return axios.post(`${base.baseURL}payconfig/payConfig`);
  },
  // POST/payconfig/query/{id} 查询------ygt
  payconfigquery(params) {
    return axios.post(`${base.baseURL}payconfig/query/${id}`, params);
  },
  // DELETE/payconfig/remove/{id} 删除
  payconfigremove(params) {
    return axios.delete(`${base.baseURL}payconfig/remove/${id}`, params);
  },
  // POST/payconfig/save 添加/修改信息------ygt
  payconfigsave(params) {
    return axios.post(`${base.baseURL}payconfig/save`, params);
  },
  /**
   *  notificationId(通知设置)
   */
  //POST /notification/cycle/{id} 设备通知周期状态------ygt
  cycleNotific(id, cycle) {
    return axios.post(`${base.baseURL}notification/cycle/${id}?cycle=` + cycle);
  },
  // POST/notification/insert/{userId}/{notificationId}添加接收人------ygt
  notificationinsert(params) {
    return axios.post(`${base.baseURL}notification/insert`, params);
  },
  // POST/notification/isOpen/{id}修改短信通知状态------ygt
  // notificationisOpen(id, isOpen) {
  //   return axios.post(`${base.baseURL}notification/isOpen/${id}?isOpen=` + isOpen);
  // },
  // POST/notification/list通知设置之通知类型查询------ygt
  notificationlist() {
    return axios.post(`${base.baseURL}notification/list`);
  },
  // DELETE/notification/remove/{id} 删除接收人------ygt
  notificationremove(id) {
    return axios.delete(`${base.baseURL}notification/remove/${id}`);
  },
  //POST   /notification/save  新增通知信息-----yzg
  saveNotific(notification) {
    return axios.post(`${base.baseURL}notification/save`, notification);
  },
  //POST   notification/isOpen/{id}修改短信通知状态------ygt
  isOpen(id, isOpen) {
    return axios.post(`${base.baseURL}notification/isOpen/${id}?isOpen=${isOpen}`);
  },
  //POST /notification/threshold/{id} 设备库存预警通知状态------ygt
  thresholdNotific(id, threshold, cycle) {
    return axios.post(`${base.baseURL}notification/threshold/${id}?threshold=` + threshold + `&cycle=${cycle}`);
  },
  //POST /notification/userNotification 查询指定接收人------ygt
  userNotification(params) {
    return axios.post(`${base.baseURL}notification/userNotification`, params);
  },
  // POST/admin/selectUserPage 分页查询选择接收人账户信息(关键字(姓名，手机号，角色名)模糊查询)------ygt
  selectUserPage(params) {
    return axios.post(`${base.baseURL}admin/selectUserPage`, params);
  },
  // POST/notification/status/{id}修改分配通知状态------ygt
  // notificationinsertstatus(id, status) {
  //   return axios.post(`${base.baseURL}notification/status/${id}?status=` + status);
  // },

  // 固件升级

  // POST/packageRecord/page ---pc api--分页查询升级包
  pagePackage(params) {
    return axios.post(`${base.baseURL}packageRecord/page`, params);
  },
  // POST/packageRecord/upgrade ---pc api--平台端控制板版本升级指令下发

  upgradePackage(params) {
    return axios.post(`${base.baseURL}packageRecord/upgrade`, params);
  },
  // POST/packageRecord/uploadFile 媒体数据上传------wy
  uploadFilePackage(params) {
    return axios.post(`${base.baseURL}packageRecord/uploadFile`, params);
  },
  // POST/packageRecord/tips/{deviceId} ---pc api--
   packageRecordTips(deviceId) {
    return axios.post(`${base.baseURL}packageRecord/tips/${deviceId}`);
  },
}
export default setting;



// WEBPACK FOOTER //
// ./src/network/setting.js